// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__krOOu","text":"style_text__0UN5z"};